import React from "react";
import { Text } from "@ilc-technology/luik";
import StarIcon from "../../../assets/icons/Star.svg";
import StarOutlineIcon from "../../../assets/icons/StarOutline.svg";
import StarOutlineDefaultIcon from "../../../assets/icons/StartOutlineHoover.svg";

interface PreferredQuoteToggleProps {
  isPreferred: boolean;
  isOutlineStarHovered: boolean;
  preferredTooltipText: string;
  preferredQuoteLabel: string;
  setAsPreferredLabel: string;
  onHoverChange: (isHovered: boolean) => void;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  withTrailingPadding?: boolean;
}

const PreferredQuoteToggle: React.FC<PreferredQuoteToggleProps> = ({
  isPreferred,
  isOutlineStarHovered,
  preferredTooltipText,
  preferredQuoteLabel,
  setAsPreferredLabel,
  onHoverChange,
  onClick,
  withTrailingPadding = true,
}) => {
  const trailingPaddingClass = withTrailingPadding ? "pr-2.5" : "";
  return isPreferred ? (
    <div className={`inline-flex flex-nowrap items-center gap-2 ${trailingPaddingClass}`}>
      <span className="rounded-sm bg-warning-light px-2 py-1">
        <Text variant="label-sm-bold">{preferredQuoteLabel}</Text>
      </span>
      <img src={StarIcon} alt="" aria-hidden="true" className="size-6.5 shrink-0" />
    </div>
  ) : (
    <div className={`relative inline-flex ${trailingPaddingClass}`}>
      <button
        type="button"
        aria-label={setAsPreferredLabel}
        className="size-6.5 relative z-[1] inline-flex cursor-pointer items-center justify-center"
        onMouseEnter={() => onHoverChange(true)}
        onMouseLeave={() => onHoverChange(false)}
        onFocus={() => onHoverChange(true)}
        onBlur={() => onHoverChange(false)}
        onClick={onClick}
      >
        <img
          src={isOutlineStarHovered ? StarOutlineDefaultIcon : StarOutlineIcon}
          alt=""
          aria-hidden="true"
          className="size-6.5 pointer-events-none"
        />
      </button>
      {isOutlineStarHovered && (
        <span className="pointer-events-none absolute -top-10 right-0 z-30 whitespace-nowrap rounded-md bg-ink-black px-3 py-2 text-xs font-bold leading-4 text-white">
          {preferredTooltipText}
          <span
            aria-hidden="true"
            className="absolute right-3 top-full h-0 w-0 border-x-[6px] border-t-[6px] border-x-transparent border-t-ink-black"
          />
        </span>
      )}
    </div>
  );
};

export default PreferredQuoteToggle;
